/**
 * Room code generation and validation.
 *
 * Room codes are 6-character uppercase alphanumeric strings.
 * Visually confusing characters (0, O, I, 1) are excluded to avoid
 * transcription errors when players share codes verbally.
 */
/** Characters used when generating room codes. */
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
/** Length of a room code. */
const CODE_LENGTH = 6;
/**
 * Generate a cryptographically-random 6-character room code.
 *
 * Uses `crypto.getRandomValues` (available in Node 22 and all modern browsers)
 * with rejection sampling to eliminate modulo bias.
 *
 * @returns A string like `"K7BNQ2"`.
 */
export function generateRoomCode() {
    const alphabetLength = ALPHABET.length; // 32 — a power of two, so no bias
    const bytes = new Uint8Array(CODE_LENGTH);
    // globalThis.crypto is available in Node 22+ and all modern browsers
    globalThis.crypto.getRandomValues(bytes);
    let code = '';
    for (let i = 0; i < CODE_LENGTH; i++) {
        code += ALPHABET[bytes[i] % alphabetLength];
    }
    return code;
}
/** Regex that matches exactly the character set used by generateRoomCode. */
const ROOM_CODE_RE = /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6}$/;
/**
 * Return `true` if `code` is a syntactically valid room code.
 *
 * This does **not** check whether the room exists on the server.
 *
 * @param code The string to validate (case-sensitive — must be uppercase).
 */
export function isValidRoomCode(code) {
    return ROOM_CODE_RE.test(code);
}
/**
 * Normalise a user-entered string into a room code candidate.
 * Uppercases the input and strips whitespace. Does not validate.
 */
export function normaliseRoomCode(raw) {
    return raw.trim().toUpperCase();
}
//# sourceMappingURL=room-codes.js.map